import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';

const Dashboard = () => {
    const navigate = useNavigate();
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const [adminCount, setAdminCount] = useState();

    useEffect(() => {
        getAdminCounts();
    }, []);

    const getAdminCounts = () => {
        const apiUrl = `/all-dashboard-count`;

        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
            .then(response => {
                setAdminCount(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    return (
        <>
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item active">
                                <span>Dashboard</span>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="body flex-grow-1 px-3">
                    <div className="container-lg">
                        <div className="row">
                            <div class="Dcard-container">

                                <div class="Dcard" onClick={() => navigate('/mobile-register-student-list')}>
                                    <i class="fa-solid fa-users-line"></i>
                                    <div className='title'><h2>Subcriber list</h2></div>
                                </div>
                                <div class="Dcard" onClick={() => navigate('/institute-grade-for-approval')}>
                                    <i class="fa-solid fa-graduation-cap"></i>
                                    <div className='title'><h2>Institute Class List</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate('/institute-subject-for-approval')}>
                                    <i class="fa-solid fa-file-lines"></i>
                                    <div className='title'><h2>Institute Subject List</h2></div>

                                </div>
                                <div class="Dcard" onClick={() => navigate('/admin-announcements-view')}>
                                    <i class="fa fa-bullhorn"></i>
                                    <div className='title'><h2>Announcements</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate("/institute-list")} >
                                    <i class="fa-solid fa-sitemap"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Institute</h4>
                                            <div className='count'>{adminCount?.adminInstituteCount?.activeInstitute + adminCount?.adminInstituteCount?.deActiveInstitute}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Active Institute</h4>
                                            <div className='count'>{adminCount?.adminInstituteCount?.activeInstitute}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Deactive Institute</h4>
                                            <div className='count'>{adminCount?.adminInstituteCount?.deActiveInstitute}</div>
                                        </li>

                                    </ul>
                                <div className='title'><h2>Institute Count</h2></div>
                                </div>

                                <div class="Dcard"  onClick={() => navigate("/dashboard-competitve-exam")} >
                                    <i class="fa-solid fa-sitemap"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Of Competitive Exam Name</h4>
                                            <div className='count'>{adminCount?.adminCompetitiveExamNameCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Competitive Exam Lesson</h4>
                                            <div className='count'>{adminCount?.adminCompetitiveExamLessonCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Competitive Exam Topic</h4>
                                            <div className='count'>{adminCount?.adminCompetitiveExamTopicCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Competitive Exam Sub Topic</h4>
                                            <div className='count'>{adminCount?.adminCompetitiveExamSubTopicCount}</div>
                                        </li>

                                    </ul>
                                    <div className='title'><h2>Competitive Exam Count</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate("/dashboard-study-material")}>
                                    <i class="fa-solid fa-book"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Pdf Books Count</h4>
                                            <div className='count'>{adminCount?.adminPdfBookCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Reference Books Count</h4>
                                            <div className='count'>{adminCount?.adminReferenceBookCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Text Book Upload Video</h4>
                                            <div className='count'>{adminCount?.adminTextBookUploadVideoCount}</div>
                                        </li>
                                        <li>
                                            <h4>Board-Medium-Class Wise Upload Video</h4>
                                            <div className='count'>{adminCount?.adminVideoCount}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Study Material Count</h2></div>
                                </div>

                                <div class="Dcard" onClick={() => navigate("/dashboard-question-bank")}>
                                    <i class="fa fa-question-circle"></i>
                                    <ul className='d-flex'>
                                        <li>
                                            <h4>Total No Text Book Question Count</h4>
                                            <div className='count'>{adminCount?.adminTextBookQuestionCount}</div>
                                        </li>
                                        <li>
                                            <h4>Total No Of Competitive Question Count</h4>
                                            <div className='count'>{adminCount?.adminCompetitiveQuestionCount}</div>
                                        </li>
                                    </ul>
                                    <div className='title'><h2>Question Bank Question Count</h2></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mt-4">  </div>

            </div>
            <Footer />
        </>
    )
};

export default Dashboard;